import { makeStyles } from '@mui/styles';
import { body1, subtitle2 } from '../../../shared/theme/text.styles';

export const useWorkStyles = makeStyles((theme) => ({
  wTitle: {
    fontWeight: '600! important',
    fontSize: '28 !important',
    paddingRight: '20px',

    [theme.breakpoints.down('lg')]: {
      paddingRight: '0',
    },

    ...subtitle2,
  },

  wDescription: {
    marginTop: '45px !important',
    paddingRight: '20px',

    [theme.breakpoints.down('lg')]: {
      paddingRight: '0',
    },

    ...body1,
  },
}));
